export default {
      id: "icon-360-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite.svg#icon-360",
      toString: function () {
        return this.url;
      }
    }